/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiLink, EuiPopover } from '@elastic/eui'

import { useToggle } from '@modules/utils/hooks/useToggle'

import type { FunctionComponent, ReactNode } from 'react'

interface Props {
  buttonText: NonNullable<ReactNode>
}

/**
 * Component representing a clickable in-line popover.
 * Similar to EuiPopover, but the clickable component is a EuiLink with some custom text.
 */
const CustomTextPopover: FunctionComponent<Props> = ({ buttonText, children }) => {
  const [isPopoverOpen, togglePopover, setPopoverOpen] = useToggle()

  return (
    <EuiPopover
      style={{ verticalAlign: 'baseline' }}
      anchorPosition='upCenter'
      ownFocus={true}
      button={<EuiLink onClick={togglePopover}>{buttonText}</EuiLink>}
      isOpen={isPopoverOpen}
      closePopover={() => setPopoverOpen(false)}
    >
      {children}
    </EuiPopover>
  )
}

export default CustomTextPopover
